import { get } from 'lodash';

const root = (state) => get(state, 'DefaultLaborHoursState');

export const getFetchLoading = (state) => get(root(state), 'fetchLoading');
export const getSaveLoading = (state) => get(root(state), 'saveLoading');
export const getSaveSuccessful = (state) => get(root(state), 'saveSuccessful');
export const getSites = (state) => get(root(state), 'sites');
export const getSaveError = (state) => get(root(state), 'saveError');
export const getFetchError = (state) => get(root(state), 'fetchError');



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/state/selectors.js